import {Attendee} from 'Event/attendee'
import {Widget} from 'Event/Widget/template'
import {OBVIO_WIDGET_LOADER_URL} from 'Event/Widget/script/config'
import {loadGoogleFont} from 'Event/Widget/script/helpers/fonts'
import {redirectToUrlAfterDelay} from 'Event/Widget/script/helpers/url'

export async function renderRedirect(
  container: HTMLElement,
  widget: Widget,
  loginUrl: Attendee['login_url'],
) {
  loadGoogleFont(
    'https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;700&display=swap',
  )

  // reset container
  container.innerHTML = ''
  container.style.width = '100%'
  container.style.display = 'flex'
  container.style.justifyContent = 'center'
  container.style.alignItems = 'center'

  const wrapper = document.createElement('div')
  wrapper.style.display = 'flex'
  wrapper.style.justifyContent = 'center'
  wrapper.style.alignItems = 'center'
  wrapper.style.width = '100%'
  wrapper.style.flexDirection = 'column'

  container.appendChild(wrapper)

  const loadingSpinner = document.createElement('img')
  loadingSpinner.style.width = '22px'
  loadingSpinner.src = OBVIO_WIDGET_LOADER_URL
  loadingSpinner.style.marginBottom = '15px'

  wrapper.appendChild(loadingSpinner)

  const loadingText = document.createElement('div')
  loadingText.innerText = widget.template.redirect.text
  loadingText.style.fontSize = '16px'
  loadingText.style.color = '#2d2d2d'
  loadingText.style.fontFamily = 'Rubik'
  loadingText.style.textAlign = 'center'

  wrapper.appendChild(loadingText)

  redirectToUrlAfterDelay(loginUrl, widget.template.redirect.delay || 0)
}
